// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import SafetyCertificateFilledSvg from "@ant-design/icons-svg/es/asn/SafetyCertificateFilled";
import AntdIcon from '../components/AntdIcon';

var SafetyCertificateFilled = function SafetyCertificateFilled(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: SafetyCertificateFilledSvg
  }));
};

SafetyCertificateFilled.displayName = 'SafetyCertificateFilled';
export default React.forwardRef(SafetyCertificateFilled);